// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qj-1";
export var spinner = "_qj-0";